import React from 'react';
import SEO from './SEO';
import Header from '../components/Header';
import CarrierCard from '../components/CarrierCard';
import { CARRIERS } from '../data/carriers';
import '../components/TrackingInterface.css';
import './CarrierCoveragePage.css';
import Footer from './Footer';

function CarrierCoveragePage() {
  return (
    <div className="carrier-coverage-page">
      <SEO
        title="Carrier Coverage"
        description="RideLink Tracking supports 11+ major ocean carriers including Maersk, MSC, CMA CGM, Hapag-Lloyd, and more — covering 95%+ of global container shipping capacity."
        canonicalPath="/carriers"
      />
      <Header />
      
      <div className="carrier-coverage-hero">
        <div className="hero-content">
          <h1 className="hero-title">Carrier Coverage</h1>
          <h2 className="hero-subtitle">Supported Shipping Lines</h2>
          <div className="hero-description-wrapper">
            <p className="hero-description">
              Covering 95% of global carriers. Get accurate track & trace data on containers and vessels across ports & terminals around the world with real-time data API.
            </p>
            <button className="hero-cta-button">
              Let's Track My Shipments
            </button>
          </div>
        </div>
      </div>

      <div className="carriers-container">
        {CARRIERS.map((carrier, index) => (
          <CarrierCard key={index} carrier={carrier} />
        ))}
      </div>
      {/* ── FOOTER ── */}
            <Footer />
    </div>
  );
}

export default CarrierCoveragePage;